import { Box, Card, Flex, Image, Text } from '@chakra-ui/react';
import CustomFlipCard from './flipCard';

const HeroesFlip = ({ data }) => {
  const clients = data.filter(
    (item) => item.attributes.customerType === 'client'
  );
  const partners = data.filter(
    (item) => item.attributes.customerType === 'partner'
  );
   
  return (
    <Box position={'relative'} mt={'3rem'} >
      <Text textAlign={"center"} fontSize="xl" fontWeight="bold" my={"1rem"}>
      Selected clients

      </Text>
      <Flex flexWrap="wrap" justify={"center"}>
        {clients.map((client) => (
          <Box key={client.attributes.url} m={4}>
            <CustomFlipCard
              data={{
                logo: client.attributes.logo.data.attributes.url,
                company: client.attributes.company,
                testimonial: client.attributes.testimonial,
              }}
              
            />
          </Box>
        ))}
      </Flex>
      <Text textAlign={"center"} fontSize="xl" fontWeight="bold" my={"1rem"}>
        Selected partners
      </Text>
      <Flex flexWrap="wrap" justify={'center'}>
        {partners.map((client) => (
          <Box key={client.attributes.url}  m={4}>
            <CustomFlipCard
              data={{
                logo: client.attributes.logo.data.attributes.url,
                company: client.attributes.company,
                testimonial: client.attributes.testimonial,
              }}
            />
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default HeroesFlip;
